var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-loader-1",class:{'is-black': _vm.isBlack}})
}
var staticRenderFns = []

export { render, staticRenderFns }